<template>
  <tooltip
    :text="tooltipText"
    :trigger="tooltipTrigger"
    placement="bottom">
    <button
      @click="handleUpdate()"
      class="borderless-button"
      :aria-label="tooltipHoverText">
      <span
        :data-feedback-type="iconName"
        :class="classList"
        aria-hidden="true">
        {{ iconName }}
      </span>
    </button>
  </tooltip>
</template>

<script>
export default {
  name: 'FeedbackButton',
  data() {
    return {
      tooltipTrigger: 'hover-focus',
      tooltipText: this.tooltipHoverText
    }
  },
  props: {
    tooltipHoverText: {
      type: String,
      required: true
    },
    feedbackValue: {
      type: String,
      required: true
    },
    activeFeedbackValue: {
      type: String,
      required: true
    },
    iconName: {
      type: String,
      required: true
    }
  },
  computed: {
    isActive() {
      return this.feedbackValue === this.activeFeedbackValue
    },
    classList() {
      let classList = ['borderless-button-content']
      if (this.isActive) {
        classList.push('material-icons')
      } else {
        classList.push('material-icons-outlined')
      }
      return classList
    },
  },
  methods: {
    handleUpdate() {
      this.$emit('updated')
      if (this.feedbackValue !== this.activeFeedbackValue) {
        this.tooltipText = 'Feedback submitted'
        setTimeout(() => {
          this.tooltipText = this.tooltipHoverText
        }, 2500)
      }
    }
  }
}
</script>
